import { webmasterConstants } from '../constants/webmaster';
import { intlConstants } from '../constants/intl';
import { webmaster } from '../services/ApiService';

export const initialization = () => ({
  type: webmasterConstants.GET_DYNAMIC_DATE,
});

export const loginFailure = err => {
  const { response: data = {} } = err;
  const { data: error = {} } = data;
  const { error: message = {}, response = {} } = error;
  const { code } = message;
  const { verification = {} } = response;

  return {
    type: webmasterConstants.LOGIN_FAILURE,
    error: message.message || err,
    code,
    verification,
  };
};

export const logout = () => ({ type: webmasterConstants.LOGOUT });

export const startLogout = () => dispatch => webmaster.logout().then(() => dispatch(logout()));

export const login = profile => ({
  type: webmasterConstants.LOGIN_SUCCESS,
  profile,
});

export const getProfile = (webmasterData = {}, verification) => dispatch => {
  const { email, login, language, img } = webmasterData;
  const profile = {
    email,
    login,
    img,
  };

  dispatch({
    type: intlConstants.SET_LOCALE,
    locale: language,
  });
  return dispatch({
    type: webmasterConstants.LOGIN_SUCCESS,
    profile,
  });
};

export const startSetEditProfile = data => dispatch => {
  return webmaster
    .setBasicInfo(data)
    .then(data => dispatch({ type: webmasterConstants.EDIT_PROFILE_SUCCESS }))
    .catch(err => dispatch({ type: webmasterConstants.EDIT_PROFILE_FAILURE }));
};

export const startLogin = (webmasterData = {}) => (dispatch, getState) => {
  return webmaster
    .login({ ...webmasterData })
    .then(data => {
      if (data.items.auth) {
        return webmaster.getBasicInfo().then(({ items }) => {
          // проверка на измененный язык на морде.
          const { language: profileLanguage, master } = items;
          const cookieLanguage = getState().intl.locale;
          if (profileLanguage !== cookieLanguage) {
            // если он другой - то вызывается редактирование профиля с этим языком
            dispatch(startSetEditProfile({ ...items, language: cookieLanguage }));
          }
          return dispatch(login(data.items));
        });
      } else {
        return dispatch(loginFailure(data));
      }
    })
    .catch(err => dispatch(loginFailure(err)));
};

export const startGetProfile = () => dispatch => {
  dispatch({ type: webmasterConstants.LOGIN_REQUEST });
  return webmaster
    .getBasicInfo()
    .then(data => {
      return dispatch(getProfile(data.items));
    })
    .catch(err => dispatch(loginFailure(err)));
};

export const getBalance = balance => ({
  type: webmasterConstants.GET_BALANCE_SUCCESS,
  balance,
});

export const startGetBalance = () => dispatch => {
  dispatch(() => ({ type: webmasterConstants.GET_BALANCE_REQUEST }));
  return webmaster
    .getBalance()
    .then(data => dispatch(getBalance(data.items)))
    .catch(err => dispatch(() => ({ type: webmasterConstants.GET_BALANCE_FAILURE })));
};

export const startLoginBySocial = (token, social) => dispatch =>
  webmaster.loginBySocial(token, social).then(data => dispatch(login(data.items)));
